export const DEFAULT_SHEET_NAME = "Sheet1";
